import ALL_LANGUAGES from '../../constants/languages';

export default function (supportedLocales: string[]): string[] {
	try {
		return supportedLocales;
	} catch (e) {
		return ALL_LANGUAGES.map(lang => lang.code);
	}
}
